<template>
    <div>
        <div id="tab-notes" class="tab" style="display: block;">
            <div class="notes-box">
                <a v-if="!addingNote" href class="btn transparent js-add-note" @click.prevent="addClick"><span>{{addingNote ? 'Cохранить' : 'Добавить заметку' }}</span></a>
                <div class="note-item" v-if="addingNote">
                    <field-wrapper :type="'textarea'" :value="newNote" @input="newNote=$event"
                                   @enter="addClick"></field-wrapper>
                    <div class="btns-box">
                        <button @click="cancelClick" type="button" class="text-btn js-cancel-btn">Отменить</button>
                        <button @click="addClick" type="button" class="text-btn js-save-btn">Сохранить</button>
                    </div>
                </div>
                <div class="notes-list">
                    <note-item v-for="note in employee.notes" :note="note" :key="note.id"
                               @edit="editCLick(note.id, $event)"></note-item>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

    import FieldWrapper from "../common/fields/FieldWrapper";
    import {mapActions} from 'vuex'
    import NoteItem from "./NoteItem";
    export default {
        name: 'current-employee-notes',
        components: {
            NoteItem,
            FieldWrapper
        },
        data() {
            return {
                mode: 0,
                addingNote: false,
                newNote: ''
            }
        },
        computed: {
            currComponent() {
                return this.mode ? 'field-wrapper' : 'field-wrapper-disabled'
            }
        },
        props: {
            employee: Object,
        },
        methods: {
            ...mapActions('people', [
                'addNote',
                'updateNote'
            ]),
            editCLick(id, e) {
                this.updateNote({id: id, note: e});
            },
            addClick() {
                if (this.addingNote) {
                    this.addNote(this.newNote).then(() => {
                        this.newNote = ''
                    });
                }
                this.addingNote = !this.addingNote;

            },
            cancelClick() {
                this.newNote = '';
                this.addingNote = !this.addingNote
            }
        },
    }
</script>

<style scoped>

</style>
